export default [
    { id: 23, name: "Airbnb", icon: "fa-airbnb", status: 1, color: "#FF7977" },
    { id: 3, name: "Facebook", icon: "fa-facebook", status: 1, color: "#3e5c9a" },
    { id: 6, name: "Flickr", icon: "fa-flickr", status: 1, color: "#006ADD" },
    { id: 26, name: "Giphy", icon: "fa-giphy", status: 1, color: "#000000" },
    { id: 4, name: "Google Review", icon: "fa-google", status: 1, color: "#4081ED", },
    { id: 2, name: "Instagram", icon: "fa-instagram", status: 1, color: "#d45662", },
    { id: 18, name: "Instagram Business", icon: "fa-instagram", status: 1, color: "#cd486b", },
    { id: 10, name: "LinkedIn", icon: "fa-linkedin", status: 1, color: "#0177B5", },
    { id: 29, name: "OnSiteUpload", icon: "fa-onsite-upload", status: 1, color: "#613983", },
    { id: 5, name: "Pinterest", icon: "fa-pinterest", status: 1, color: "#E60022", },
    { id: 12, name: "RSS", icon: "fa-rss", status: 1, color: "#f78422" },
    { id: 20, name: "Slack", icon: "fa-slack", status: 1, color: "#510d4e" },
    { id: 25, name: "SoundCloud", icon: "fa-soundcloud", status: 0, color: "#FC5502", },
    { id: 28, name: "TikTok", icon: "fa-tiktok", status: 1, color: " #000000" },
    { id: 11, name: "Tumblr", icon: "fa-tumblr", status: 1, color: "#36465d" },
    { id: 1, name: "Twitter", icon: "fa-twitter", status: 1, color: "#29a9e1" },
    { id: 8, name: "Vimeo", icon: "fa-vimeo-square", status: 1, color: "#1eb8eb", },
    { id: 30, name: "VKontakte", icon: "fa-vk", status: 1, color: "#0077ff" },
    { id: 15, name: "Workplace", icon: "fa-workplace", status: 1, color: "#4767AB", },
    { id: 21, name: "Yammer", icon: "fa-yammer", status: 1, color: "#0078D4" },
    { id: 19, name: "Yelp", icon: "fa-yelp", status: 1, color: "#be362e" },
    { id: 7, name: "YouTube", icon: "fa-youtube", status: 1, color: "#FF0000" },
  ];
  